const settings = window.measurementSelectorVariables;

export default {
	state: (): { activeEdgeFinish: string } => ({
		activeEdgeFinish: 'sawing',
	}),
	mutations: {
		updateActiveEdgeFinish( state, activeEdgeFinish ): void {
			state.activeEdgeFinish = activeEdgeFinish;
		},
	},
	getters: {
		isEdgeFinishVisible: (state, getters): boolean => {
			if ( getters.shape && getters.getPricingGroup.get_shape_settings(getters.exportShape).customer_choose_production_method ) {
				return true;
			}

			return false;
		},
		getEdgeFinishMethods: ( state, getters, rootState, rootGetters ): {
			value: string;
			label: string;
		}[] => {
			const methods = settings.i18n.edgeFinish.methods;

			// Any sawing method that has a price defined, becomes available for all enabled shapes.
			const availableMethods = Object.entries(methods).filter((value) => {
				const price = rootGetters.getPricingGroup.get_sawing_selling_price_per_m(value[0], rootGetters.exportShape);
				return price > 0;
			});

			const defaultEdgeFinish = getters.getDefaultEdgeFinish;

			// Add default sawing method as edge finish option
			if( defaultEdgeFinish && !availableMethods.find((value) => value[0] === defaultEdgeFinish) ) {
				availableMethods.push([defaultEdgeFinish, methods[defaultEdgeFinish]]);
			}

			return availableMethods.map( (value) => ({
				value: value[0],
				label: value[1] as string,
			}) );
		},
		getDefaultEdgeFinish: ( state, getters, rootState, rootGetters ): string => {
			const shapeSettings = rootGetters.getPricingGroup.get_shape_settings(rootGetters.exportShape);
			return shapeSettings.sawing_method;
		},
		activeEdgeFinish( state, getters ): string {
			const methods = getters.getEdgeFinishMethods;
			if(methods.find((method) => method.value === state.activeEdgeFinish)) {
				return state.activeEdgeFinish;
			}
			return getters.getDefaultEdgeFinish;
		},
	},
};
